import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { STATUS } from 'domains/product/constants/product-constants'


const propTypes = {
  product_status: PropTypes.string
}

/**
 * To give nice look on `product_status`.
 * It maps `status` to certain style and pass to `StatusBadge`.
 * @param {string} status Product status. available values
 * - `disabled`
 * - `enabled`
 */
const ProductStatusBadge = ({ product_status }) => {

  const colorMap = {
    [STATUS.ENABLED]  : 'success',
    [STATUS.DISABLED] : 'danger'
  }

  const color = colorMap[product_status]

  return <StatusBadge color={ color } label={ product_status } />
}

ProductStatusBadge.propTypes = propTypes

export default ProductStatusBadge